const initialState = () => ({
  surveys: [],
  items: [],
  sections: [],
  survey: null,
  config: null,
  locations: [],
  publishedStatus: 0,
})

export default initialState
